import React from "react";
import { Button, useTheme } from "@mui/material";
import { AutoAwesome } from "@mui/icons-material";

export interface AIGradientButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  size?: "small" | "medium" | "large";
  additionalStyles?: React.CSSProperties;
}

export default function AIGradientButton(props: AIGradientButtonProps) {
  const theme = useTheme();

  const styles = props.disabled ? {} : {
    position  : "relative",
    background: theme.colors.namedColors.aiGradient,
    backgroundSize: "400% 400%",
    // animation: 'button-shimmer 8s ease-in-out infinite',
    color: theme.colors.namedColors.aiButtonText,
    textTransform: "none",
    // border: '2px solid transparent',
    boxShadow: `0 0 0 ${theme.colors.namedColors.chart3}`,
    // transform: "scale(1) rotate(0deg)",
    // "@keyframes button-shimmer": {
    //   "0%": {
    //     backgroundPosition: "0% 0%"
    //   },
    //   "50%": {
    //     backgroundPosition: "100% 100%"
    //   },
    //   "100%": {
    //     backgroundPosition: "0% 0%"
    //   },
    // },
    "&:hover": {
      border: `2px solid ${theme.colors.namedColors.chart1}`,
      boxShadow: `0 0 10px ${theme.colors.namedColors.chart3}`,
      textShadow: `0 0 2px ${theme.colors.namedColors.chart1Dark}`,
      transform: "scale(1.05)",
      transition: "all 0.2s ease-in-out",
    }
  };

  return (
    <Button
      size={props.size || "medium"}
      variant="contained"
      onClick={props.onClick}
      disabled={props.disabled}
      sx={{...styles, ...props.additionalStyles}}
      startIcon={<AutoAwesome />}
    >
      {props.children}
    </Button>
  );
}